export const isAuthenticated = (state) => {
  if (state.auth.auth.idToken) return true;
  return false;
};

export const isPasswordChangeRequired = (state) => {
  return state.auth.passwordChangeRequired;
};

export const getPendingEmail = (state) => {
  return state.auth.pendingEmail;
};

export const getAuthLoading = (state) => {
  return state.auth.showLoading;
};

export const getAuthError = (state) => {
  return state.auth.errorMessage;
};

export const getAuthSuccess = (state) => {
  return state.auth.successMessage;
};
